import { useEffect, useState, useContext } from 'react';
import '../../App.scss';
import '../../css/forms.scss';
import BaseContainer from '../../components/Container';
import TabHeader from '../../components/TabHeader';
import BaseForm from '../../components/BaseForm';
import SubmitButton from '../../components/SubmitButton';
import { serverFetch, serverPatch } from '../../helpers/server';
import { BaseContext } from '../../helpers/common';
import { useParams, useSearchParams } from "react-router-dom";
import { getTabItems } from '../../helpers/tabs'
import { Row, Col } from 'react-bootstrap';
import Notification from '../../components/Notification';
import { useTranslation } from 'react-i18next';
const _ = require("lodash");

function MultiGroup() {
    const { getApiUrl, getFacilityName } = useContext(BaseContext);
    let { facilityLink } = useParams();
    const [venueDetails, setVenueDetails] = useState({});
    const [ searchParams ] = useSearchParams();
    const venueId = searchParams.get('id');
    const { t } = useTranslation('common');

    useEffect(() => {
        document.title = `${venueDetails.name} (Multi Group) - ${getFacilityName()}`;
    }, [facilityLink, venueDetails]);

    useEffect(() => {
        serverFetch(getApiUrl(`/venues/${venueId}`)).then((res) => {
            setVenueDetails(res);
        });
    }, [venueId]);

    const updateSettings = (data) => {
        serverPatch(getApiUrl(`/venues/${venueId}/settings`), data, {}).then((res) => {
            if (res) {
                Notification.Show(t('notification.successfully_updated'));
            }
        });
    }

    const allowedGroupsOptions = _.range(4).map((r) => { return { value: ""+(r+1), label: ""+(r+1) } });

    const tabsParams = {
        searchParams: venueId && `id=${venueId}`,
        venueName: venueDetails.name
    };
    return (
        <BaseContainer>
            <TabHeader items={getTabItems(t, facilityLink, "venue-settings", tabsParams)}/>
            <BaseForm initialFormFields={venueDetails} onSubmit={updateSettings}>
                <div className="content-box">
                    <div className="content-header">{t("setting.multigroup.title")}</div>
                    <div className="content-body">
                        <Row>
                        <Col md="7">
                        <Row>
                            <BaseForm.Input colSpan="6" name="noOfGroups" label={t("setting.multigroup.allowed")} type="select"
                                options={allowedGroupsOptions} rightContent="Groups" showSearch={false} />
                            <BaseForm.Input colSpan="6" name="minGroups" label={t("setting.multigroup.min_allowed")} type="select"
                                options={allowedGroupsOptions} rightContent="Groups" showSearch={false} />
                            <BaseForm.Input colSpan={12} name={'usersToSelectGroups'} label={t("setting.multigroup.allow_customer_select")} type={'check'} />
                            <BaseForm.Input colSpan={12} name={'showCPC'} label={t("setting.multigroup.cpc")} type={'check'} />
                            <BaseForm.Input colSpan={12} name={'CPCPaidUnpaid'} label={t("setting.multigroup.cpc_paid")} type={'check'} />
                            <BaseForm.Input colSpan={12} name={'usersToAddGroups'} label={t("setting.multigroup.allow_user_add")} type={'check'} />
                            <BaseForm.Input colSpan={12} name={'allowSplitBooking'} label={t("setting.multigroup.allow_split")} type={'check'} />
                            <BaseForm.Input colSpan={12} name={'mustBookPairs'} label={t("setting.multigroup.must_book_pairs")} type={'check'} />
                            <BaseForm.Input colSpan={12} name={'twoGroupsMax'} label={t("setting.multigroup.max_60_min")} type={'check'} />
                        </Row>
                        </Col>
                        </Row>
                    </div>
                </div>
                <div className="content-box">
                    <div className="content-body">
                        <SubmitButton variant="primary">{t("common.save")}</SubmitButton>
                    </div>
                </div>
            </BaseForm>
        </BaseContainer>
    );
}

export default MultiGroup;
